<div class="row ml-3 mt-2">
  <div class="col">
    <small (click)="showSearchResult = false" *ngIf="accountCategory== 'RENTAL_FLEET'">
      <a [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console&nbsp;</a>
      /<a class="text-secondary pointer">&nbsp;Usage&nbsp;</a>
    </small>
    <small (click)="showSearchResult = false" *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'">
      <a [routerLink]="['/commercial-fleet']" class="text-secondary">Admin Console&nbsp;</a>
      /<a class="text-secondary pointer">&nbsp;Usage&nbsp;</a>
    </small>
    <small *ngIf="showSearchResult">
      <a class="text-secondary pointer" (click)="searchResult.onNavSearchClick()"> / Search</a>
      <a *ngIf="selectedSearchItemForView" class="text-secondary"> / {{selectedSearchItemForView}}</a>
    </small>
  </div>
</div>

<div *ngIf="showSearchResult" class="row mt-2">
  <div class="col-12">
    <app-search-results [usageList]="searchedUsageList" #searchResult></app-search-results>
  </div>
</div>

<div *ngIf="!showSearchResult">
<div class="col-sm-12 card bg-light p-2 mt-3">
  <div class="text-secondary mb-2 font13-400">Please select time period for which you want to
    view Service Usage</div>
  <div>
    <label>Select Period:&nbsp;&nbsp;</label>
    <select id="loc" class="w-25" [(ngModel)]="selectedSelectionRange" (change)="onUsageRangeChange($event.target.value)" name="selectionOption" #selectionOption="ngModel">
      <!-- <option value="-1">Select Range</option> -->
      <option *ngFor="let dateRange of usageSelectionOption; let i = index;" value={{dateRange}}>
        {{dateRange}}
      </option>
    </select>
    <span *ngIf="isDateRangeSelected">
      <label>&nbsp;&nbsp;&nbsp;From:&nbsp;</label>
      <p-calendar class="ml-2" name="fromDate" [maxDate]="selectedToDate" [(ngModel)]="selectedFromDate"></p-calendar>
      <label>&nbsp;&nbsp;To:&nbsp;</label>
      <p-calendar class="ml-2" name="toDate" [minDate]="selectedFromDate" [maxDate]="today"
        [(ngModel)]="selectedToDate"></p-calendar>
      <button class="ml-2 btn btn-outline-danger btn-sm pt-0 pb-0" (click)="getDateWiseServiceUsageBetweenDates()">
        <span class="maroon"><i class="fa fa-angle-double-right"></i></span></button>
    </span>
  </div>
</div>




<div class="row mt-3 no-gutter scroll-height-screenHeight">
  <div class="col-sm-12 col-md table-responsive">
    <table class="table table-striped">
      <thead class="thead-light cursor-pointer">
        <tr>
          <th width="15%" scope="col" (click)="onSortByDateClick()">Date Time&nbsp;&nbsp;<span *ngIf="selectedSortColumn == columns[0]"><i
              *ngIf="selectedSortType == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
              *ngIf="selectedSortType == sortType[0]" class="fa fa-arrow-down" aria-hidden="true"></i></span></th>
          <!-- <th scope="col">CorrelationId&nbsp;&nbsp;</th> -->
          <th width="25%" scope="col" (click)="onSortByCorrelationIdClick()">Correlation Id&nbsp;&nbsp;<span *ngIf="selectedSortColumn == columns[1]"><i *ngIf="selectedSortType == sortType[1]"
            class="fa fa-arrow-up" aria-hidden="true"></i><i *ngIf="selectedSortType == sortType[0]"
            class="fa fa-arrow-down" aria-hidden="true"></i></span></th>
          <th width="15%" scope="col" (click)="onSortByVinClick()">VIN&nbsp;&nbsp;<span *ngIf="selectedSortColumn == columns[2]"><i *ngIf="selectedSortType == sortType[1]"
              class="fa fa-arrow-up" aria-hidden="true"></i><i *ngIf="selectedSortType == sortType[0]"
              class="fa fa-arrow-down" aria-hidden="true"></i></span></th>
          <th width="13%" scope="col" (click)="onSortByLocationClick()" style="word-break: unset;">Location&nbsp;&nbsp;<span *ngIf="selectedSortColumn == columns[3]"><i
              *ngIf="selectedSortType == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
              *ngIf="selectedSortType == sortType[0]" class="fa fa-arrow-down" aria-hidden="true"></i></span></th>
          <th width="15%" scope="col" (click)="onSortByServiceNameClick()">Service Name&nbsp;&nbsp;<span *ngIf="selectedSortColumn == columns[4]"><i
              *ngIf="selectedSortType == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
              *ngIf="selectedSortType == sortType[0]" class="fa fa-arrow-down" aria-hidden="true"></i></span></th>
          <th width="10%" scope="col" (click)="onSortByRequestTypeClick()">Request Type&nbsp;&nbsp;<span *ngIf="selectedSortColumn == columns[5]"><i
              *ngIf="selectedSortType == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
              *ngIf="selectedSortType == sortType[0]" class="fa fa-arrow-down" aria-hidden="true"></i></span></th>
          <th width="7%" scope="col" (click)="onSortByStatusClick()">Status&nbsp;&nbsp;<span *ngIf="selectedSortColumn == columns[6]"><i
              *ngIf="selectedSortType == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
              *ngIf="selectedSortType == sortType[0]" class="fa fa-arrow-down" aria-hidden="true"></i></span></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let usage of usageUiData; let i = index">
          <tr *ngIf="usage.vin && usage.operationStatus != 'PENDING'">
            <td>{{usage.requestTime | date:'MM/dd/y h:mm:ss a'}}</td>
            <!-- <td style="word-break:break-word;">{{usage.correlationId}}</td> -->
            <td class="w-break">{{usage.correlationId}}</td>
            <td class="w-break">{{usage.vin}}</td>
            <td
              *ngIf="usage.facilityLocation != null && usage.facilityLocation.address != null && usage.facilityLocation.address.city != null">
              {{usage.facilityLocation.address.city}}</td>
            <td
              *ngIf="usage.facilityLocation == null || usage.facilityLocation.address == null || usage.facilityLocation.address.city == null">
            </td>
            <td>{{usage.serviceName | customText}}</td>
            <td>{{usage.operation | customText}}</td>
            <td>{{usage.operationStatus | customText}}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div *ngIf="usageUiData == null || usageUiData.length < 1" class="col-sm-12 col-md text-center">
      <h3 class="text-muted">No Data Available</h3>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div *ngIf="usageUiData && usageUiData.length > 0" class="col-sm-12 col-md text-right">
    <span class="pointer" *ngIf="usagePageInfo && usagePageInfo.prev" (click)="getPreviousPage()"> << Previous</span> &nbsp;&nbsp;&nbsp;&nbsp;
    <span class="pointer" *ngIf="usagePageInfo && usagePageInfo.next" (click)="getNextPage()"> Next >> </span>
  </div>
</div>
</div>

<!-- <div class="row pt-3">
  <div class="col-sm-12 col-md table-responsive no-gutter">
    <table class="table table-striped">
      <thead class="cursor-pointer thead-light">
        <tr>
          <th width="20%" scope="col" (click)="onSortByDateClick()">Date Time&nbsp;&nbsp;<i
              *ngIf="selectedDateSortType == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
              *ngIf="selectedDateSortType == sortType[0]" class="fa fa-arrow-down" aria-hidden="true"></i></th>
          <th width="20%" scope="col" (click)="onSortByVinClick()">VIN&nbsp;&nbsp;<i *ngIf="selectedVinSortType == sortType[1]"
              class="fa fa-arrow-up" aria-hidden="true"></i><i *ngIf="selectedVinSortType == sortType[0]"
              class="fa fa-arrow-down" aria-hidden="true"></i></th>
          <th width="15%" scope="col" (click)="onSortByLocationClick()">Location&nbsp;&nbsp;<i
              *ngIf="selectedLocationSortType == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
              *ngIf="selectedLocationSortType == sortType[0]" class="fa fa-arrow-down" aria-hidden="true"></i></th>
          <th width="20%" scope="col" (click)="onSortByServiceNameClick()">Service Name&nbsp;&nbsp;<i
              *ngIf="selectedServiceNameSortType == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
              *ngIf="selectedServiceNameSortType == sortType[0]" class="fa fa-arrow-down" aria-hidden="true"></i></th>
          <th width="15%" scope="col" (click)="onSortByRequestTypeClick()">Request Type&nbsp;&nbsp;<i
              *ngIf="selectedRequestTypeSortType == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
              *ngIf="selectedRequestTypeSortType == sortType[0]" class="fa fa-arrow-down" aria-hidden="true"></i></th>
          <th width="10%" scope="col" (click)="onSortByStatusClick()">Status&nbsp;&nbsp;<i
              *ngIf="selectedStatusSortType == sortType[1]" class="fa fa-arrow-up" aria-hidden="true"></i><i
              *ngIf="selectedStatusSortType == sortType[0]" class="fa fa-arrow-down" aria-hidden="true"></i></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let usage of usageUiData; let i = index">
          <tr *ngIf="usage.vin && usage.operationStatus != 'PENDING'">
            <td>{{usage.requestTime | date:'MMM d, y h:mm:ss a'}}</td>
            <td class="w-break">
                {{usage.vin}}
            </td>
            <td
              *ngIf="usage.facilityLocation != null && usage.facilityLocation.address != null && usage.facilityLocation.address.city != null">
              {{usage.facilityLocation.address.city}}</td>
            <td
              *ngIf="usage.facilityLocation == null || usage.facilityLocation.address == null || usage.facilityLocation.address.city == null">
            </td>
            <td>{{usage.serviceName | customText}}</td>
            <td>{{usage.operation | customText}}</td>
            <td>{{usage.operationStatus | customText}}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div *ngIf="usageUiData == null || usageUiData.length < 1" class="col-sm-12 col-md text-center">
      <h3 class="text-muted">No Data Available</h3>
    </div>
  </div>
</div> -->